export default "/_next/static/images/solutions--support-7850eabcec67843661d3c993c679eceb.svg";